var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add-icon-2",
    transform: "translate(-1528 -133)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "plus",
    transform: "translate(1546.923 151.923)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10983",
    "data-name": "Group 10983",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10982",
    "data-name": "Group 10982",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M149.08,140.719H144.7v-4.385a1.1,1.1,0,1,0-2.192,0v4.385h-4.385a1.1,1.1,0,0,0,0,2.193H142.5V147.3a1.1,1.1,0,1,0,2.192,0v-4.385h4.385a1.1,1.1,0,0,0,0-2.193Z",
    transform: "translate(-137.022 -135.238)",
    fill: "#c0c2c6"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5157",
    "data-name": "Rectangle 5157",
    width: 15,
    height: 15,
    rx: 4,
    transform: "translate(1528 133)",
    fill: "#c0c2c6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5158",
    "data-name": "Rectangle 5158",
    width: 15,
    height: 15,
    rx: 4,
    transform: "translate(1546 133)",
    fill: "#c0c2c6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5159",
    "data-name": "Rectangle 5159",
    width: 15,
    height: 15,
    rx: 4,
    transform: "translate(1528 151)",
    fill: "#c0c2c6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateIcon2);
export default __webpack_public_path__ + "static/media/create-icon-2.d8eca3f5f9dd62c5f3e71fe3071ee417.svg";
export { ForwardRef as ReactComponent };